/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Font_Size_LabelInputs */



/**
* | output |
* | --- |
* | "Font Size" |
*
* @param {Styles_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_font_size_label = /** @type {((inputs?: Styles_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille de police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftgröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione del carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño de fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォントサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho da fonte")
	return /** @type {LocalizedString} */ ("Font Size")
});